import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { ErrorBoundary } from '#client/components/ErrorBoundary';
import { ENABLE_BACKUP_CARD_DASHBOARD_BILLING } from '#client/constants/experimentsFlags';
import { useBanners } from '#client/hooks/useBanners';

import * as Styled from './BillingBackupCardBanner.style';

// The banners API has no banner identifier; the storage key prefix is the only stable marker.
const BACKUP_CARD_STORAGE_KEY_PREFIX = 'banner/BackupCard/';

function BackupCardBanner() {
  const { data } = useBanners();
  const banner = data.find(({ storageKey }) => storageKey?.startsWith(BACKUP_CARD_STORAGE_KEY_PREFIX));

  if (!banner) {
    return null;
  }

  return (
    <Styled.Banner
      clickstreamProps={{ appSection: 'billing' }}
      slotProps={{ primaryAction: { href: banner.primaryCta.url, label: banner.primaryCta.label } }}
      storageKey={banner.storageKey}
      subtitle={banner.description}
      title={banner.title}
      variant={banner.type}
    />
  );
}

// Gated here so users without the flag never make a banners request from Billing.
function BillingBackupCardBanner() {
  const isEnabled = useExperimentFlag(ENABLE_BACKUP_CARD_DASHBOARD_BILLING, false);

  return isEnabled ? (
    <ErrorBoundary id="src/Billing#BackupCardBanner">
      <BackupCardBanner />
    </ErrorBoundary>
  ) : null;
}

export default BillingBackupCardBanner;
